/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setDepositPreference} from '../api'

export const useMutationSetDepositPreference = createReactQueryMutationHook('setDepositPreference', setDepositPreference)
